export default __webpack_public_path__ + "assets/8a2c3c8e33277577433e17d67fd8a763.jpg";